import React from "react";
import { useTranslation } from "@1f/react-sdk";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";
import Stack from "@vapor/react-material/Stack";
import Button from "@vapor/react-material/Button";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const DashboardImport = ({
  isARicDesktopActive,
  onGoToImportDesktop,
}) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ width: "100%", minHeight: 160 }}>
      <CardContent sx={{ p: 0, pb: "0 !important" }}>
        <Stack direction="row" sx={{ flexWrap: "wrap" }}>
          <Stack
            direction="column"
            sx={{
              flex: "1 1 320px",
              minWidth: 0,
              p: { xs: 2, md: 4 },
            }}
            spacing={1}
          >
            <ExtendedTypography variant="titleSmall" color="primary.main">
              {t("dashboard.amlDesktop")}
            </ExtendedTypography>
            <ExtendedTypography variant="body" color="text.secondary">
              {t("dashboard.importDesc")}
            </ExtendedTypography>
            <Button
              variant="contained"
              size="small"
              sx={{ width: { xs: "100%", sm: "200px" } }}
              onClick={() => onGoToImportDesktop("aricdesktop")}
              disabled={!isARicDesktopActive}
            >
              {t("dashboard.proceed")}
            </Button>
          </Stack>
          <Stack
            direction="column"
            sx={{
              flex: "1 1 420px",
              minWidth: 0,
              p: { xs: 2, md: 4 },
            }}
            spacing={1}
          >
            <ExtendedTypography variant="titleSmall" color="primary.main">
              TS Studio Contabilità, Paghe, Redditi e ViaLibera
            </ExtendedTypography>
            <ExtendedTypography variant="body" color="text.secondary">
              Importa i tuoi fascicoli da altri applicativi TS
            </ExtendedTypography>
            <Button
              variant="contained"
              size="small"
              sx={{ width: { xs: "100%", sm: "200px" } }}
              onClick={() => onGoToImportDesktop("multi")}
            >
              {t("dashboard.proceed")}
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
